import React from 'react';
import Decimal from 'decimal.js';
import { SwapData, TokenInfo } from '../types';

interface Props {
    trades: SwapData[];
    token: TokenInfo;
    coins: TokenInfo[];
}

function fmt(s: string): string {
    try {
        return new Decimal(s).toSignificantDigits(6).toString();
    } catch {
        return s;
    }
}

function symbolFor(addr: string, coins: TokenInfo[]): string {
    const c = coins.find((c) => c.address.toLowerCase() === addr.toLowerCase());
    return c ? c.symbol : addr.slice(0, 8);
}

export default function TradeHistory({ trades, token, coins }: Props) {
    return (
        <div className="card">
            <h2>Recent Trades — {token.symbol}</h2>
            <table>
                <thead>
                    <tr>
                        <th>Time</th>
                        <th>Source</th>
                        <th>Pair</th>
                        <th>Amount in</th>
                        <th>Amount out</th>
                        <th>Price</th>
                        <th>Tx</th>
                    </tr>
                </thead>
                <tbody>
                    {trades.length === 0 && (
                        <tr>
                            <td colSpan={7} className="empty">
                                no trades yet
                            </td>
                        </tr>
                    )}
                    {trades.map((t) => (
                        <tr key={`${t.txHash}-${t.logIndex}`}>
                            <td>{new Date(t.blockTime).toLocaleTimeString()}</td>
                            <td>
                                <span className={`tag ${t.source === 'trade' ? 'ok' : 'muted-tag'}`}>
                                    {t.source}
                                </span>
                            </td>
                            <td>
                                {symbolFor(t.tokenIn, coins)} → {symbolFor(t.tokenOut, coins)}
                            </td>
                            <td>{fmt(t.amountIn)}</td>
                            <td>{fmt(t.amountOut)}</td>
                            <td>{fmt(t.price)}</td>
                            <td title={t.txHash}>{t.txHash.slice(0, 10)}…</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
